import { DashboardModal } from "@dashboard/components/Modal";
import { SaleCollectionProductsQuery } from "@dashboard/graphql";
import ProductDiscountPrice from "@dashboard/products/components/ProductDiscountPrice";
import { Box, Button, Text } from "@saleor/macaw-ui-next";
import { FormattedMessage } from "react-intl";

type ProductNode = NonNullable<
  NonNullable<SaleCollectionProductsQuery["collection"]>["products"]
>["edges"][number]["node"];

interface ProductDiscountPricesDialogProps {
  open: boolean;
  product: ProductNode | null;
  onClose: () => void;
}

export const ProductDiscountPricesDialog = ({
  open,
  product,
  onClose,
}: ProductDiscountPricesDialogProps) => {
  const variants = product?.variants ?? [];

  return (
    <DashboardModal open={open} onChange={onClose}>
      <DashboardModal.Content size="md">
        <DashboardModal.Header>
          <FormattedMessage
            defaultMessage="Discount prices for {name}"
            id="TMDppV"
            description="dialog title"
            values={{ name: product?.name ?? "" }}
          />
        </DashboardModal.Header>

        <Box display="flex" flexDirection="column" gap={4}>
          {variants.length === 0 ? (
            <Text color="default2">
              <FormattedMessage
                defaultMessage="This product has no variants to discount."
                id="gDo01+"
              />
            </Text>
          ) : (
            variants.map(variant => (
              <Box key={variant.id} display="flex" flexDirection="column" gap={2}>
                {variants.length > 1 && (
                  <Text size={3} fontWeight="bold">
                    {variant.name}
                  </Text>
                )}
                <ProductDiscountPrice
                  productId={product?.id ?? ""}
                  variantId={variant.id}
                  channelListings={(variant.channelListings ?? []).map(listing => ({
                    id: listing.channel.id,
                    name: listing.channel.name,
                    currency: listing.channel.currencyCode,
                    price: listing.price?.amount != null ? listing.price.amount.toString() : "",
                  }))}
                />
              </Box>
            ))
          )}
        </Box>

        <DashboardModal.Actions>
          <Button variant="secondary" onClick={onClose}>
            <FormattedMessage defaultMessage="Close" id="rbrahO" />
          </Button>
        </DashboardModal.Actions>
      </DashboardModal.Content>
    </DashboardModal>
  );
};

export default ProductDiscountPricesDialog;
